import { expressApi } from '@/state/api/expressApi';
import type {
  BatchRiskAnalysisResponseDto,
  LaneDecisionRequestDto,
  LaneDecisionResponseDto,
} from '@/types';

export const analysisApi = expressApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * GET /batches/{batchId}/risk-analysis — fetch risk analysis for an upload batch.
     * Returns BatchRiskAnalysisResponseDto with per-document risk levels and lane suggestions.
     */
    getBatchRiskAnalysis: builder.query<BatchRiskAnalysisResponseDto, string>({
      query: (batchId) => `/batches/${batchId}/risk-analysis`,
      providesTags: ['RiskAnalysis'],
    }),

    /**
     * POST /documents/{documentId}/lane-decision — submit the user's lane decision for a document.
     * Body: LaneDecisionRequestDto (decision, and the optional styleGuide chosen for an AI-Direct file).
     * Target languages are derived server-side from the upload batch, so they are not sent here.
     * Returns LaneDecisionResponseDto with the created jobId.
     */
    postLaneDecision: builder.mutation<
      LaneDecisionResponseDto,
      { documentId: string; body: LaneDecisionRequestDto }
    >({
      query: ({ documentId, body }) => ({
        url: `/documents/${documentId}/lane-decision`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['TranslationJobs'],
    }),
  }),
});

export const {
  useGetBatchRiskAnalysisQuery,
  useLazyGetBatchRiskAnalysisQuery,
  usePostLaneDecisionMutation,
} = analysisApi;
